import classNames from 'classnames';
import React from 'react';
import { Container } from 'semantic-ui-react';
import SuperTemplateBreadcrumbs from './SuperTemplateBreadcrumbs';
const SubcategoryHeroBanner = (props) => {
  const { title, theme, introContent, image, mobileimage, cta, ctaAriaLabel, postTags } = props.module;

  return (
    <section className={`subcategory-hero-banner__background subcategory-hero-banner__${theme}`}>
      <Container>
        <div className="grid-wrapper">
          <div
            className={classNames('subcategory-hero-banner__container', {
              'subcategory-hero-banner__no-mobile-img': !mobileimage,
            })}
          >
            <div className="subcategory-hero-banner__content">
              {title ? <h1 className={'subcategory-hero-banner__heading heading-one'}>{title}</h1> : null}
              {introContent ? <p className="subcategory-hero-banner__intro-content body-one">{introContent}</p> : null}
              {cta ? (
                <a
                  href={cta.url}
                  target={cta.target || '_self'}
                  className="subcategory-hero-banner__btn"
                  aria-label={ctaAriaLabel ? ctaAriaLabel : null}
                >
                  {cta.title}
                </a>
              ) : null}
            </div>

            <div className="subcategory-hero-banner__image">
              {image ? <img className="subcategory-hero-banner__desktop-img" src={image.sourceUrl} alt={image.altText} /> : null}
              {mobileimage ? (
                <img className="subcategory-hero-banner__mobile-img" src={mobileimage.sourceUrl} alt={mobileimage.altText} />
              ) : null}
            </div>
          </div>
          {props?.breadcrumbs ? (
            <div className="subcategory-hero-banner__breadcrumbs-wrapper">
              <SuperTemplateBreadcrumbs breadcrumbs={props.breadcrumbs} />
            </div>
          ) : null}
        </div>
      </Container>
    </section>
  );
};

export default SubcategoryHeroBanner;
